<template>
  <div id="nbiotMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>路侧场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>地磁管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row class="pageSearch">
        <el-col :span="22">
          <el-form-item label="客户名称::">
            <el-select v-model="pageSearch.fCustID"
                       @change="changeCust($event,'search')"
                       filterable
                       clearable
                       placeholder="请选择客户">
              <el-option v-for="item in custList"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       clearable
                       placeholder="请选择场库">
              <el-option v-for="item in searchParkList"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态::">
            <el-select v-model="pageSearch.fStatus"
                       filterable
                       clearable
                       placeholder="请选择状态"
                       style="width: 100px">
              <el-option v-for="item in statusList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车位编号::">
            <el-input placeholder="请输入车位编号"
                      style="width: 100px"
                      v-model="pageSearch.fPlaceNo">
            </el-input>
          </el-form-item>
          <el-form-item label="设备ID::">
            <el-input placeholder="请输入设备ID"
                      v-model="pageSearch.fDeviceID">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="2"
                class="searchRowAdd">
          <el-button type="primary"
                     size="small"
                     v-if="is_edit"
                     @click="handleAdd(false)">新增地磁
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号"
                           align="right">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           width="80"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fPlaceNo"
                           width="80"
                           label="车位编号">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="90"
                           label="车牌">
          </el-table-column>
          <el-table-column prop="fDeviceID"
                           label="设备ID">
          </el-table-column>
          <el-table-column prop="fStatusName"
                           width="60"
                           label="状态">
          </el-table-column>
          <el-table-column prop="fDevRssi"
                           label="信号强度"
                           align="right"
                           width="80">
          </el-table-column>
          <el-table-column prop="fDevBat"
                           label="设备电量(%)"
                           align="right"
                           width="100">
          </el-table-column>
          <el-table-column prop="fDevVer"
                           width="90"
                           label="设备版本">
          </el-table-column>
          <el-table-column prop="fHeartTime"
                           label="心跳时间">
          </el-table-column>
          <el-table-column prop="fErrCodeStr"
                           label="异常状态">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="330">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="success"
                         :disabled="!(scope.row && scope.row.fPlateCode && scope.row.fPlateCode.length) > 0"
                         @click="viewCar(scope.$index, scope.row)">车辆信息</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_edit"
                         @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         v-if="is_del"
                         @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="curRowInfo"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户::"
                          prop="fCustID">
              <el-select v-model="curRowInfo.fCustID"
                         @change="changeCust($event,'form')"
                         filterable
                         :disabled="formDisabled"
                         style="width:100%"
                         placeholder="请选择客户">
                <el-option v-for="item in custList"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="场库::"
                          prop="fParkID">
              <el-select v-model="curRowInfo.fParkID"
                         filterable
                         @change="changePark"
                         :disabled="formDisabled"
                         style="width:100%"
                         placeholder="请选择场库">
                <el-option v-for="item in parkList"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车位编号::"
                          prop="fPlaceNo">
              <el-select v-model="curRowInfo.fPlaceNo"
                         filterable
                         :disabled="formDisabled"
                         style="width:100%"
                         placeholder="请选择车位编号">
                <el-option v-for="item in placeNoList"
                           :key="item.fPlaceNo"
                           :label="item.fPlaceNo"
                           :value="item.fPlaceNo">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="厂家::"
                          prop="fDevProdID">
              <el-select v-model="curRowInfo.fDevProdID"
                         filterable
                         :disabled="formDisabled"
                         style="width:100%"
                         placeholder="请选择厂家">
                <el-option v-for="item in devProdList"
                           :key="item.value"
                           :label="item.text"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度::"
                          prop="fLongitude">
              <el-input v-model="curRowInfo.fLongitude"
                        :disabled="formDisabled"
                        placeholder="请填写经度"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度::"
                          prop="fLatitude">
              <el-input v-model="curRowInfo.fLatitude"
                        :disabled="formDisabled"
                        placeholder="请填写纬度"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备ID::"
                          prop="fDeviceID">
              <el-input v-model="curRowInfo.fDeviceID"
                        :disabled="formDisabled"
                        placeholder="请填写设备ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="高度::"
                          prop="fHigh">
              <el-input v-model="curRowInfo.fHigh"
                        :disabled="formDisabled"
                        placeholder="请填写高度"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!formDisabled">保存</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="viewDialogTitle"
               width="55%"
               top="7vh"
               v-loading="true"
               :visible.sync="viewDialogFormVisible"
               v-dialogDrag>
      <el-form ref="form"
               :model="curRowViewInfo"
               label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="客户编号">
              <el-input v-model="curRowViewInfo.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称">
              <el-input v-model="curRowViewInfo.fCustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场库编号">
              <el-input v-model="curRowViewInfo.fParkNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="场库名称">
              <el-input v-model="curRowViewInfo.fParkName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车位编号">
              <el-input v-model="curRowViewInfo.fPlaceNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备ID">
              <el-input v-model="curRowViewInfo.fDeviceID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-input v-model="curRowViewInfo.fStatusName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="信号强度">
              <el-input v-model="curRowViewInfo.fDevRssi"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备电量">
              <el-input v-model="curRowViewInfo.fDevBat"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="设备版本">
              <el-input v-model="curRowViewInfo.fDevVer"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="心跳时间">
              <el-input v-model="curRowViewInfo.fHeartTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="异常状态">
              <el-input v-model="curRowViewInfo.fErrCodeStr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="经度">
              <el-input v-model="curRowViewInfo.fLongitude"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="纬度">
              <el-input v-model="curRowViewInfo.fLatitude"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高度">
              <el-input v-model="curRowViewInfo.fHigh"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="24">
          <el-table :data="pageViewData"
                    height="200"
                    v-loading="viewLoading"
                    border
                    stripe
                    style="width: 100%;overflow-y: auto">
            <el-table-column width="50"
                             type="index"
                             :index="indexViewMethod"
                             label="序号">
            </el-table-column>
            <el-table-column prop="fOpLastTimeStr"
                             width="180"
                             label="操作时间">
            </el-table-column>
            <el-table-column prop="fDevCmd"
                             width="200"
                             label="指令">
            </el-table-column>
            <el-table-column prop="fDevData"
                             label="设备数据">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row class="pagination">
        <el-col :span="24">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleViewCurrentChange"
                         @size-change="handleViewSizeChange"
                         :current-page="pageViewSearch.pageIndex"
                         :page-size="pageViewSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pageViewCount"
                         v-if="pageViewCount>0">
          </el-pagination>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="viewDialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <roadSideCarInfoView ref="child"
                         :type="1"></roadSideCarInfoView>
  </div>
</template>
<script>
import roadSideCarInfoView from '../../components/roadSideCarInfoView'
import * as api from '../../api/park'
import * as user from '../../api/user'
export default {
  components: { roadSideCarInfoView },
  data () {
    return {
      is_edit: false,
      is_del: false,
      tableHeight: 0,
      statusList: [],
      custList: [],
      parkList: [],
      placeNoList: [],
      devProdList: [],
      searchParkList: [],
      loading: false,
      viewLoading: false,
      dialogFormVisible: false,
      viewDialogFormVisible: false,
      formDisabled: false,
      dialogTitle: '',
      viewDialogTitle: '',
      pageData: [],
      pageViewData: [],
      pageCount: 0,
      pageViewCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fStatus: '',
        fDeviceID: '',
        fPlaceNo: ''
      },
      pageViewSearch: {
        pageIndex: 1,
        pageSize: 20
      },
      curRowViewInfo: {
        fDcDevID: '',
        fOpLastTime: '',
        fOpUserID: '',
        fCustID: '',
        fCustNo: '',
        fParkID: '',
        fParkNo: '',
        fPlaceNo: '',
        fDevProdID: '1',
        fDeviceID: '',
        fDevRssi: '',
        fDevBat: '',
        fDevVer: '',
        fHeartTime: '',
        fStatusTime: '',
        fStatus: '',
        fErrCode: '',
        fErrCodeStr: '',
        fLongitude: '',
        fLatitude: '',
        fHigh: ''
      },
      curRowInfo: {
        fDcDevID: '',
        fCustID: '',
        fCustNo: '',
        fParkID: '',
        fParkNo: '',
        fPlaceNo: '',
        fDevProdID: '1',
        fDeviceID: '',
        fLongitude: '',
        fLatitude: '',
        fHigh: ''
      },
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fPlaceNo: [
          { required: true, message: '请选择车位编号', trigger: 'change' }
        ],
        fDeviceID: [
          { required: true, message: '请输入设备ID', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      api.nbiotList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载场库车位列表失败')
          }
        }
      })
    },
    changeCust (val, type) {
      if (type === 'search') {
        this.pageSearch.fParkID = ''
      } else {
        this.curRowInfo.fParkID = ''
      }
      api.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (type === 'search') {
              this.searchParkList = data.Data || []
            } else {
              this.parkList = data.Data || []
            }
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    changePark (val) {
      var param = {}
      param.pageIndex = 1
      param.pageSize = 999999
      param.fCustID = this.curRowInfo.fCustID
      param.fParkID = this.curRowInfo.fParkID
      param.fAreaName = ''
      param.fPlaceNo = ''
      api.parkPlaceList(param).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.placeNoList = data.Data.data || []
          } else {
            this.$message.error('提示：加载场库车位列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    indexViewMethod (index) {
      return this.pageViewSearch.pageSize * (this.pageViewSearch.pageIndex - 1) + index + 1
    },
    handleViewSizeChange (val) {
      this.pageViewSearch.pageSize = val
      this.initView(this.pageViewSearch.pageIndex)
    },
    handleViewCurrentChange (val) {
      this.initView(val)
    },
    initView (index) {
      if (index && index >= 1) {
        this.pageViewSearch.pageIndex = index
      } else {
        this.pageViewSearch.pageIndex = 1
      }
      this.pageViewData = []
      this.pageViewCount = 0
      this.viewLoading = true
      this.curRowViewInfo.pageIndex = this.pageViewSearch.pageIndex
      this.curRowViewInfo.pageSize = this.pageViewSearch.pageSize
      api.nbiotViewList(this.curRowViewInfo).then(res => {
        this.viewLoading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageViewData = data.Data.data || []
            this.pageViewCount = data.Data.count
          } else {
            this.$message.error('提示：加载地磁明细失败')
          }
        }
      })
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    viewCar (index, row) {
      let fPlateCode = row.fPlateCode
      if (row && fPlateCode && fPlateCode.length > 0) {
        this.$refs.child.handleInfo(row)
      }
    },
    handleInfo (index, row) {
      this.viewDialogTitle = '查看地磁信息'
      this.viewDialogFormVisible = true
      Object.assign(this.curRowViewInfo, row)
      this.initView()
      // this.dialogTitle = '查看场库车位'
      // if ((row.fCustName || '').length > 0) {
      //   var strTitle = row.fCustName
      //   if ((row.fParkName || '').length > 0) {
      //     strTitle += '-' + row.fParkName
      //   }
      //   this.dialogTitle = '【' + strTitle + '】查看场库车位'
      // }
      // this.formDisabled = true
      // if (this.$refs['ruleForm']) {
      //   this.$refs['ruleForm'].resetFields()
      // }
      // this.place = { isBatch: false }
      // this.dialogFormVisible = true
      // api.nbiotInfo(row.fBigRowID).then(res => {
      //   if (res && res.data) {
      //     var data = res.data
      //     if (data.IsOk) {
      //       data.Data = data.Data || {}
      //       data.Data.isBatch = false
      //       this.place = data.Data || {}
      //     } else {
      //       this.$message.error('提示：' + data.Msg)
      //     }
      //   }
      // })
    },
    handleEdit (index, row) {
      this.dialogTitle = '编辑地磁'
      this.formDisabled = false
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormVisible = true
      Object.assign(this.curRowInfo, row)
      let parkId = this.curRowInfo.fParkID
      this.changeCust(this.curRowInfo.fCustID)
      this.curRowInfo.fParkID = parkId
      this.changePark()
    },
    handleDelete (index, row) {
      this.$confirm('删除该客户[' + row.fCustName + ']的场库[' + row.fParkName + ']的车位[' + row.fPlaceNo + ']的地磁[' + row.fDeviceID + '], 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.nbiotDelete(row.fDcDevID).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.init()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    handleAdd () {
      this.dialogTitle = '新增地磁'
      this.curRowInfo = {
        fDcDevID: '',
        fCustID: '',
        fCustNo: '',
        fParkID: '',
        fParkNo: '',
        fPlaceNo: '',
        fDevProdID: '1',
        fDeviceID: ''
      }
      this.parkList = []
      setTimeout(() => {
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate()
        }
      }, 50)
      this.formDisabled = false
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.curRowInfo.fParkNo = ''
          let tmpPark = this.parkList.filter(item => {
            if (item.fParkID === this.curRowInfo.fParkID) { return item }
          })
          if (tmpPark && tmpPark.length > 0) {
            this.curRowInfo.fParkNo = tmpPark[0].fParkNo
          } else {
            this.$message.error('请选择场库')
          }
          api.nbiotEdit(this.curRowInfo).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 220
      obj.tableHeight = clientHeight
    },
    loadOptions () {
      api.getCustByGroup({ fCustTypeID: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.custList = data.Data || []
          } else {
            this.$message.error('加载客户列表失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 250000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.statusList.push({ text: '占用', value: '1' })
    this.statusList.push({ text: '空闲', value: '0' })
    this.devProdList.push({ text: '易姆讯', value: '1' })
    this.init()
    this.loadOptions()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#nbiotMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#nbiotMain .el-dialog__title {
  color: white;
}
#nbiotMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#nbiotMain .el-dialog__body {
  padding: 15px 20px 0px 20px;
}
#nbiotMain .is-disabled .el-input__inner,
#nbiotMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#nbiotMain #fRemark {
  height: 180px;
}
#nbiotMain .fRemark_row .el-form-item__content {
  height: 180px;
}
#nbiotMain .pageSearch .el-form-item {
  margin-bottom: 10px;
}
</style>

<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/nbiotMain.vue